// removed by extract-text-webpack-plugin
module.exports = {"root":"SocialIcons__root--2_SjQ","button":"SocialIcons__button--_Re2H","circle":"SocialIcons__circle--2nd4R","container":"SocialIcons__container--1U_qc","icon":"SocialIcons__icon--245Iz","clipboardWapper":"SocialIcons__clipboardWapper--3ALu2","clipboardConfirm":"SocialIcons__clipboardConfirm--1Dh3R"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/SocialIcons/SocialIcons.css
// module id = ./src/components/Library/SocialIcons/SocialIcons.css
// module chunks = 2